export default __webpack_public_path__ + "static/media/mixg day2_201103.48bfc401.jpg";